(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["air-selector"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const productData = JSON.parse(document.getElementById('productData').textContent);
  
  console.log('Product Data:', productData);
  
  const airManagement = document.getElementById('air-management');
  const airLineSize = document.getElementById('air-line-size');
  const compressor = document.getElementById('compressor');
  const tank = document.getElementById('tank');
  const showButton = document.getElementById('show-button');
  const recommendations = document.getElementById('airSelectorRecommendations');

  // Add product data with images and URLs
  const productDataArray = Object.values(productData);

  function calculateManagementPartNumber(management, lineSize) {
    if (management === 'Manual') return 'ALF27666';

    const partNumbers = {
      '3H': {
        '1/4 inch': 'ALF27690',
        '3/8 inch': 'ALF27695'
      },
      '3P': {
        '1/4 inch': 'ALF27680',
        '3/8 inch': 'ALF27685'
      }
    };

    return partNumbers[management]?.[lineSize] || 'Unknown';
  }

  function calculateCompressorTankPartNumber(compressor, tank) {
    if (compressor === 'None' || !tank) return null;

    // For dual setups, convert to single for the tank combo
    const singleCompressor = compressor.startsWith('Dual') 
      ? compressor.replace('Dual', 'Single')
      : compressor;

    const partNumbers = {
      'Single Viair 444c Black': {
        '2.5 Gal. Polished': 'ALF27805',
        '4 Gal. 5-Port Polished': 'ALF27806',
        '4 Gal. 7-port Polished': 'ALF27807',
        '5 Gal. Polished': 'ALF27808'
      },
      'Single Viair 444c Chrome': {
        '2.5 Gal. Polished': 'ALF27801',
        '4 Gal. 5-Port Polished': 'ALF27802',
        '4 Gal. 7-port Polished': 'ALF27803',
        '5 Gal. Polished': 'ALF27804'
      }
    };

    return partNumbers[singleCompressor]?.[tank] || 'Unknown';
  }

  function calculateSecondaryCompressorPartNumber(compressor) {
    if (!compressor.startsWith('Dual')) return null;

    const partNumbers = {
      'Dual Viair 444c Black': 'ALF27751',
      'Dual Viair 444c Chrome': 'ALF27750'
    };

    return partNumbers[compressor] || 'Unknown';
  }

  function handleManualMode() {
    const isManual = airManagement.value === 'Manual';
    
    [airLineSize, compressor, tank].forEach(select => {
      select.disabled = isManual;
      if (isManual) {
        select.value = '';
      }
    });

    showButton.disabled = !airManagement.value || (!isManual && (!airLineSize.value || !compressor.value || !tank.value));
  }

  function checkAllSelected() {
    const isManual = airManagement.value === 'Manual';
    const isCompressorNone = compressor.value === 'None';
    
    if (isManual) {
      showButton.disabled = false;
      return;
    }

    const allSelected = 
      airManagement.value !== '' && 
      airLineSize.value !== '' && 
      compressor.value !== '' && 
      (isCompressorNone || tank.value !== '');
    
    showButton.disabled = !allSelected;
  }

  function createProductCard(product, type) {
    const card = document.createElement('div');
    card.className = 'recommendation-card';
    card.setAttribute('data-part-type', type);
    
    const imageContent = typeof product.image === 'string' 
      ? `<img src="${product.image}" alt="${product.title}" class="recommendation-card__image-img">`
      : product.image;
    
    card.innerHTML = `
      <a href="${product.url}" class="recommendation-card__link">
        <div class="recommendation-card__image">
          ${imageContent}
        </div>
        <div class="recommendation-card__details">
          <h3 class="recommendation-card__title">${product.title}</h3>
          <div class="recommendation-card__price">$${product.price.toFixed(2)}</div>
          <div class="recommendation-card__stock">
            <span class="stock-dot ${product.stockCount > 0 ? 'in-stock' : 'out-of-stock'}"></span>
            <span class="stock-text">${product.stockCount > 0 ? `In Stock (${product.stockCount > 10 ? '10+' : product.stockCount})` : 'On Backorder'}</span>
          </div>
        </div>
      </a>
      <button type="button" class="recommendation-card__add-to-cart" 
        data-variant-id="${product.variantId}"
        ${!product.inStock ? 'disabled' : ''}>
        ${product.inStock ? 'Add to Cart' : 'Sold Out'}
      </button>
    `;

    // Add AJAX add to cart functionality
    const addToCartBtn = card.querySelector('.recommendation-card__add-to-cart');
    addToCartBtn.addEventListener('click', async function(e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      
      try {
        this.textContent = 'Adding...';
        this.disabled = true;

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        });

        if (!response.ok) throw new Error('Add to cart failed');
        const addedItem = await response.json();

        // Get updated cart data
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        
        // Update cart count bubbles
        document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
          bubble.textContent = cartData.item_count;
          bubble.classList.remove('hide');
        });

        // Trigger cart refresh event for theme
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: {
              cart: cartData
            }
          })
        );

        // Trigger cart added notification
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:added', {
            bubbles: true,
            detail: {
              item: addedItem.items[0],
              cart: cartData
            }
          })
        );

        // Update cart drawer if it exists
        if (window.updateCartDrawer) {
          window.updateCartDrawer(cartData);
        }

        // Show success feedback
        this.textContent = 'Added!';
        setTimeout(() => {
          this.textContent = 'Add to Cart';
          this.disabled = false;
        }, 2000);

      } catch (error) {
        console.error('Error adding to cart:', error);
        this.textContent = 'Error';
        setTimeout(() => {
          this.textContent = 'Add to Cart';
          this.disabled = false;
        }, 2000);
      }
    });
    
    return card;
  }

  function updateRecommendations(type, products) {
    const grid = document.getElementById('recommendationsGrid');
    
    // Remove existing cards of this type
    const existingCards = grid.querySelectorAll(`[data-part-type="${type}"]`);
    existingCards.forEach(card => card.remove());
    
    // Add new cards if products exist
    if (products && products.length > 0) {
      products.forEach(product => {
        if (product && productData[product]) {
          const card = createProductCard(productData[product], type);
          grid.appendChild(card);
        }
      });
    }
  }

  airManagement.addEventListener('change', function() {
    if (this.value === '') {
      this.selectedIndex = 0;
    }
    handleManualMode();
    checkAllSelected();
  });

  compressor.addEventListener('change', function() {
    if (this.value === '') {
      this.selectedIndex = 0;
    }
    const isCompressorNone = this.value === 'None';
    
    if (isCompressorNone) {
      tank.disabled = true;
      tank.value = '';
    } else {
      tank.disabled = airManagement.value === 'Manual';
    }
    
    checkAllSelected();
  });

  [airLineSize, tank].forEach(select => {
    select.addEventListener('change', function() {
      if (this.value === '') {
        this.selectedIndex = 0;
      }
      checkAllSelected();
    });
  });

  showButton.addEventListener('click', function() {
    const isManual = airManagement.value === 'Manual';
    const managementPN = calculateManagementPartNumber(airManagement.value, airLineSize.value);
    let compressorTankPNs = [];
    let secondaryCompressorPNs = [];
    
    if (!isManual && compressor.value !== 'None') {
      // Get compressor tank part number
      if (tank.value) {
        const tankPN = calculateCompressorTankPartNumber(compressor.value, tank.value);
        console.log('Tank PN:', tankPN);
        if (tankPN && tankPN !== 'Unknown') compressorTankPNs.push(tankPN);
      }

      // If it's a dual compressor, get the secondary compressor part number
      if (compressor.value.startsWith('Dual')) {
        const secondaryPN = calculateSecondaryCompressorPartNumber(compressor.value);
        console.log('Secondary PN:', secondaryPN);
        console.log('Product Data for Secondary:', productData[secondaryPN]);
        if (secondaryPN && secondaryPN !== 'Unknown') secondaryCompressorPNs.push(secondaryPN);
      }
    }
    
    // Update recommendations with arrays of part numbers
    console.log('Updating recommendations with:', {
      management: [managementPN].filter(pn => pn && pn !== 'Unknown'),
      compressor: compressorTankPNs,
      secondary: secondaryCompressorPNs
    });

    updateRecommendations('management', [managementPN].filter(pn => pn && pn !== 'Unknown'));
    updateRecommendations('compressor', compressorTankPNs);
    updateRecommendations('secondary', secondaryCompressorPNs);
    
    // Show recommendations section
    if (recommendations) {
      recommendations.style.display = 'block';
      recommendations.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    // Log the part numbers for verification
    console.log('Part Numbers:', {
      management: managementPN,
      compressorTank: compressorTankPNs,
      secondary: secondaryCompressorPNs
    });
  });

  handleManualMode();

  const tooltipTriggers = document.querySelectorAll('.tooltip-trigger');
  const modal = document.getElementById('info-modal');
  const modalTitle = modal.querySelector('.modal-title');
  const modalBody = modal.querySelector('.modal-body');
  const modalClose = modal.querySelector('.modal-close');

  const tooltipContent = {
    'Air Management System': {
      title: 'Air Management System Options',
      content: `<!-- Air Management System -->
<p><strong>3P (Pressure-Based Management)</strong> – The <strong>Air Lift Performance 3P Management System</strong> controls your air suspension by monitoring air pressure in each bag rather than the physical ride height. This is a <strong>simpler, straight-forward, and cost-effective choice</strong> that allows you to set and save your preferred pressures for different driving situations—whether that’s low for a stance look, medium for daily driving, or high for clearing speed bumps. Since the system is pressure-based, minor adjustments may be needed when adding passengers or cargo to compensate for weight changes, which can be done with the press of a button on the fly. However, for most users, <strong>3P provides all the precision and adjustability needed</strong> without added sensors or complexity. It’s <strong>upgradeable</strong> to 3H later if you decide to add height sensors.</p>
<p><strong>3H (Height-Based Management)</strong> – The <strong>Air Lift Performance 3H Management System</strong> adds <strong>height sensors</strong> to each corner of your vehicle, actively adjusting air pressure to maintain a specific ride height, no matter the load. This means if you have extra passengers, a trunk full of gear, or uneven road conditions, <strong>the system will automatically adjust in real time</strong> to keep your car at the exact preset height you select. This makes 3H an appealing option for people who prioritize <strong>a consistent stance and eliminating the manual adjustment of pressures</strong> across different driving conditions. While it comes at a higher cost and a little extra complexity than 3P, it eliminates the need for manual pressure adjustments.</p>
<p><strong>Which one is right for you?</strong> If you want an easy to install and use, cost-effective air management system that delivers full control, go with 3P. This is what the vast majority of our customers go for. However if you don't mind the added complexity and cost, and place a higher preference on wanting a "set-it-and-forget-it" system that maintains your exact ride height no matter what, <strong>3H is the way to go</strong>.</p>`
    },
    'Air Line Size': {
      title: 'Air Line Size Guide',
      content: `<!-- Air Line Size -->
<p><strong>1/4” Air Lines</strong> – The <strong>most common choice</strong> for daily-driven vehicles and general air ride setups. 1/4” lines allow for <strong>smoother and more gradual adjustments</strong>, preventing abrupt movements that might be too jarring for daily driving. They are also <strong>more flexible and easier to route</strong>, making installation cleaner and more manageable, especially in tight areas. Because they restrict airflow slightly more than larger lines, the system takes an extra second or two to lift or lower the vehicle—but for many, this is actually a <strong>preferred feel</strong> rather than an aggressive drop.</p>
<p><strong>3/8” Air Lines</strong> – If you’re looking for <strong>faster height adjustments</strong>, 3/8” lines are the way to go. These larger-diameter lines flow <strong>significantly more air</strong>, meaning your car will raise and drop much more quickly—perfect for <strong>show cars, aggressive stance setups, or anyone who loves dramatic height changes</strong>. However, they can be a little <strong>stiffer to install</strong>, requiring careful routing to avoid kinks or tight bends. Additionally, the rapid response can feel a bit "snappy" compared to the controlled feel of 1/4” lines, so personal preference plays a role in choosing the right setup.</p>
<p><strong>Choose 1/4” if you want smoother, more controlled operation that’s easy to install.</strong> Choose <strong>3/8” if you want the fastest possible response</strong> and don’t mind a bit more effort in the installation process. We recommend sticking to 1/4" lines unless you have a specific requirement that would necessitate 3/8", on most builds.</p>`
    },
    'Compressor': {
      title: 'Compressor Selection Guide',
      content: `<!-- Compressor -->
<p><strong>Single Viair 444C</strong> – The <strong>simpler and more compact</strong> option, a single <strong>Viair 444C</strong> compressor provides <strong>reliable air supply for most daily-driven air suspension setups</strong>. With a <strong>100% duty cycle at 100 PSI</strong>, it can handle frequent height adjustments, but because it only has one motor, it may take longer to refill the air tank—especially if you have a larger 4 or 5-gallon setup.</p>
<p><strong>Dual Viair 444C</strong> – Adding a <strong>second compressor doubles the power</strong>, significantly cutting down tank fill times. This is <strong>especially beneficial for larger tanks (4 or 5 gallons)</strong> or for those who frequently adjust their ride height throughout the day. Dual compressors reduce strain on each unit, helping to extend their lifespan while ensuring you always have a full supply of air ready to go. <strong>Another key advantage? Redundancy.</strong> If one compressor ever fails, you still have a backup, ensuring you’re never left without air.</p>
<p><strong>If you adjust your height often or run a larger tank, go with dual compressors.</strong> If you want a simpler setup and don’t mind slightly longer refill times, a <strong>single 444C is a solid, reliable choice</strong>.</p>`
    },
    'Tank': {
      title: 'Air Tank Options',
      content: `<!-- Tank Size -->
<p><strong>2.5 Gallon Tank</strong> – The <strong>smallest and most compact option</strong>, a 2.5-gallon tank is <strong>great for tight installations</strong> where trunk space is limited. It <strong>fills up quickly</strong> and works well if you only make occasional ride height adjustments. However, because it stores less air, it will require <strong>more frequent compressor refills</strong> after a few height changes.</p>
<p><strong>4 Gallon Tank</strong> – The <strong>best all-around option</strong> for most builds. It provides <strong>enough air capacity</strong> for multiple adjustments before needing to refill, while still maintaining a <strong>reasonable size for installation</strong> in most vehicles. If you want a balance of <strong>air storage, performance, and practicality</strong>, 4 gallons is the way to go.</p>
<p><strong>5 Gallon Tank</strong> – If you need <strong>maximum air reserve</strong>, a 5-gallon tank gives you the most volume—allowing for <strong>faster, repeated height changes</strong> without worrying about running out of air. This is <strong>ideal for show cars or builds that require constant adjustments</strong>, but keep in mind that it’s <strong>physically larger</strong> and takes longer to fill. A <strong>dual compressor setup is recommended</strong> with a 5-gallon tank to maintain quick recovery times.</p>
<p><strong>If space is tight, go with 2.5 gallons.</strong> If you want the best mix of size and performance, <strong>4 gallons is ideal on most builds.</strong> If you air up/down often and have the room, <strong>5 gallons will keep you moving without delay</strong>.</p>`
    }
  };

  tooltipTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const type = trigger.parentElement.querySelector('h3').textContent.replace(':', '');
      const content = tooltipContent[type];
      
      modalTitle.textContent = content.title;
      modalBody.innerHTML = content.content;
      modal.classList.add('visible');
    });
  });

  modalClose.addEventListener('click', () => {
    modal.classList.remove('visible');
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.classList.remove('visible');
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('visible')) {
      modal.classList.remove('visible');
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
